/**
 * Renglón de ItemPromocionWeb devuelto por peticionPromocionesWebEC dentro de
 * promocion.items. Se usa para promociones tipo N (NxM) y M (Combo), que ya no
 * dependen de regla1/regla2 sino de esta lista de artículos.
 */
export interface PromoItemEcommerce {
  marca: number;
  codigo: number;
  cantidad1: number;
  cantidad2: number;
  precioReal: number;
}
